<template>
    <div class="card-ajuda">
        <g-card :expansivel="false" :temCabecalho="false">
            <div class="cabecalho-formulario">
                <div class="titulo-formulario titulo-ficha-cadastral"> Ajuda </div>
            </div>

            <div class="ajuda-conteudo espacamento">
                <div class="imagem-ajuda">
                    <img class="card-ajuda-img" src="@/assets/imgs/ilustra_ajuda.svg">
                </div>

                <div class="label-imagem-ajuda">
                    <div class="titulo-grupo-detalhes"> A ajuda abrirá automaticamente em uma nova janela </div>
                </div>

                <div class="label-link-ajuda">
                    <div class="label-conteudo-resumo-final"> Caso possua algum bloqueador de Pop-up a tela não será aberta </div>
                </div>

                <div class="link-ajuda"><a href="https://www.grupojauense.com.br/" style="color: #4f2c19;" target="_blank"> Abrir manualmente </a></div>
            </div>
      </g-card>
    </div>
</template>

<script>
import Ajuda from './Ajuda.js' 
export default Ajuda
</script>

<style scoped>
.espacamento {
    padding: 6em 0 3em;
}

.ajuda-conteudo {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}

.card-ajuda-img {
    margin-bottom: 15px;
}

.titulo-grupo-detalhes, .label-conteudo-resumo-final {
    padding: 0;
    margin: 0;
    text-align: center;
    border: none;
}

@media (min-width:310px) {
.card-ajuda-img {
    height: 14em;
}

.titulo-grupo-detalhes {
    font-size: 20px;
}
}

@media (min-width:368px) {

}

@media (min-width:600px) {
.titulo-formulario {
    font-size: 24px;
}
}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
.card-ajuda-img {
    height: 15em;
}

.titulo-grupo-detalhes {
    font-size: 22px;
}
}

@media (min-width:1281px) { 
    
}

@media (min-width:1500px) {
.titulo-formulario {
    font-size: 25px;
}
}
</style>

